package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.COLON_SPLITTER
import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.extensions.matches
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.splitByRegex
import com.eladfinish.bible.contest.extensions.toJson
import com.eladfinish.bible.contest.screens.chapterComplete.model.SavedCompletionData
import com.eladfinish.bible.contest.utils.RegexUtils.UNDERSCORES
import io.github.aakira.napier.Napier

class GetJsonEncodedBlanksUseCase {

    operator fun invoke(
        indexPickedBook: Int,
        num: Int,
        selectedText: String,
    ): String {

        var jsonEncodedBlanks: String
        val text: String = selectedText.replaceRegex(regex = MAKAF + "", replacement = "$MAKAF ")
        var verses: List<String> = text.split(COLON_SPLITTER)
        if (verses[verses.lastIndex].trim().isEmpty()) {
            verses = verses.subList(fromIndex = 0, toIndex = verses.lastIndex)
        }
        val words: MutableList<MutableList<String>> = MutableList(verses.size) { mutableListOf() }
        val blanks = ArrayList<ArrayList<Int>>()
        try {
            for (i in verses.indices) {
                val temp = ArrayList<Int>()
                words[i] = verses[i].splitByRegex(StringConstants.REGEX_SPACE).toMutableList()
                if (words[i][0].isEmpty()) {
                    words[i] = words[i].subList(1, words[i].size)
                }
                // j starts at 1, because the first element is ot pasuk
                for (j in 1 until words[i].size) {
                    words[i][j] = words[i][j].replaceRegex(regex = UNDERSCORES, replacement = "_")
                    if (words[i][j].matches(regexString = ".*_")) {
                        temp.add(j)
                    }
                }
                blanks.add(temp)
            }
            val pickedBookEng = BooksRepository.bookNamesEnglish[indexPickedBook - 1]
            val pickedBookHeb = BooksRepository.bookNamesHebrew[indexPickedBook - 1]

            val savedCompletionData = SavedCompletionData(
                pickedBookEng = pickedBookEng,
                pickedBookHeb = pickedBookHeb,
                bookIndex = indexPickedBook,
                chapter = num,
                blanks = blanks,
            )

            Napier.e("savedCompletionData_ $savedCompletionData")
            jsonEncodedBlanks = savedCompletionData.toJson<SavedCompletionData>()
        } catch (e: Exception) {
            AppCrashlytics.logException(e)
            jsonEncodedBlanks = e.message!!
        }
        return jsonEncodedBlanks
    }

}
